import { useMemo } from 'react'
import type { AsyncState } from '../../../platform/async/Async'
import { useCategories, useMostUsed } from '../useCategories'
import { buildPickerModel, type PickerModel } from './pickerModel'

/** The picker's data: one read of the cached categories list, its `most_used` included. */
export function usePickerModel(): AsyncState<PickerModel> {
  const categories = useCategories()
  const mostUsed = useMostUsed()
  return useMemo((): AsyncState<PickerModel> => {
    if (categories.status === 'success') return { status: 'success', data: buildPickerModel(categories.data, mostUsed) }
    if (categories.status === 'stale') return { ...categories, data: buildPickerModel(categories.data, mostUsed) }
    return categories
  }, [categories, mostUsed])
}
